import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import studentinfoicon from '../../../images/icons/studentinfo.png';
import pencil from '../../../images/icons/pencil.png';
import diploma from '../../../images/icons/diploma.png';
import education from '../../../images/icons/education.png';

class StaticFeed extends PreLoginPage {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
	  // this.getLiveFeedData();
  }

  componentWillMount(){
	//this.getLiveFeedData();
  }
  render() {	
  	return(
  		<section className=''>
		 	<div className="container staticfeed"> 
		 	 	<div className="row scorecardLessons text-center padd">
						
								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={education} /><br/>
			    		  <span>5000</span>
						 
						  </div>
						  <div className="card-body card-text">	
							<div>{this.rb("staticfeed.teacher")}</div>
			      	  </div> 
								</div>

								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={pencil} /><br/>
			    		  <span>10,00,000</span>
						  </div> 
						  <div className="card-body card-text">	
							<div>{this.rb("staticfeed.student")}</div>
			      	  </div> 
								</div>

								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={diploma} /><br/>
			    		  <span>30%</span>
						  </div> 
						  <div className="card-body card-text">	
		    				<div>{this.rb("staticfeed.improveInfo")}</div>
			      	  </div> 
							
								</div>

								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={studentinfoicon} /><br/>
			    		  <span style={{}}>92%</span>
						 
						  </div>
						  <div className="card-body card-text">	
		    				<div>{this.rb("staticfeed.studentsInfo")}</div>
			      	  </div> 
							
								</div>
								
				</div>
		 	 </div> 
		</section>
  	);
  }
}

export default StaticFeed;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/StaticFeed.js